import TableContainer from "Components/Common/TableContainer";
import { getSectionByIdApi } from "helpers/ApiManager";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { PaginatedPayload } from "types/ApiResponse";
import { QuoteDetailsPayload } from "types/quote.api";
import { SectionPayloadData } from "types/section.api";

interface QuoteSectionsProps {
  quoteDetails: QuoteDetailsPayload;
}

const QuoteSections: React.FC<QuoteSectionsProps> = ({ quoteDetails }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sections, setSections] =
    useState<PaginatedPayload<SectionPayloadData> | null>(null);

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage(page);
  }, []);

  const columns = useMemo(() => {
    const baseColumns = [
      {
        header: "ORDER",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => cell.row.index + 1,
      },
      {
        header: "SECTION",
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span className="fw-normal text-black2D fs-14 font-primary">
            {cell.getValue() ? cell.getValue() : "-"}
          </span>
        ),
      },
      {
        header: "DESCRIPTION",
        accessorKey: "content",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span
            className="fw-normal text-black2D fs-14 font-primary"
            dangerouslySetInnerHTML={{ __html: cell.getValue() ?? "-" }}
          />
        ),
      },
    ];

    return baseColumns;
  }, [quoteDetails]);

  useEffect(() => {
    const fetchSections = async () => {
      if (quoteDetails?.id) {
        const res = await getSectionByIdApi(quoteDetails.id, currentPage);
        setSections(res.payload);
      }
    };

    fetchSections();
  }, [quoteDetails, currentPage]);

  return (
    <div className="d-flex flex-column p-3 bg-white br-10">
      <div className="fw-medium fs-16 text-black2D">Job description</div>

      <div className="border-bottom my-3 mx-n4"></div>

      <TableContainer
        columns={columns}
        data={sections?.data || []}
        customPageSize={sections?.data.length || 0}
        divClass="table-responsive table-card mb-2 bg-white"
        tableClass="align-middle  table-borderless"
        thClass="text-grey89 fw-medium fs-14 font-primary bg-greyF5 category-table"
        theadClass="table-light"
        SearchPlaceholder="Search clients"
        onPageChange={handlePageChange}
        isClientDetails={false}
        totalPages={sections?.meta?.last_page || 0}
        currentPage={sections?.meta?.current_page || 0}
        fromPage={sections?.meta?.from}
        toPage={sections?.meta?.to}
        totalItems={sections?.meta?.total}
        isListFilter={true}
      />
    </div>
  );
};

export default React.memo(QuoteSections);
